<template>
  <div>
    <template v-if="dataClosing.row.closing === 0">
      <button class="btn btn-info custom-shadow-btn" @click="handleClosings()">
        {{ $t('common_words.close') }}
      </button>
    </template>
    <template v-else-if="dataClosing.row.closing === 1">
      <button
        class="btn btn-warning custom-shadow-btn"
        @click="handleClosings()"
      >
        {{ $t('common_words.open') }}
      </button>
    </template>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  name: 'button-closing',
  props: {
    dataClosing: {
      type: Object,
    },
  },
  mixins: [mixinMasters, MixinPermissions],

  methods: {
    handleClosings() {
      const operation =
        Number(this.dataClosing.row.closing) === 0 ? 'Cerrar' : 'Abrir';
      SweetAlert.default(
        `${operation} ${i18n.t('sweet_alert.jobs.selected_worker_record')}`,
        `${i18n.t(
          'sweet_alert.jobs.confirm_record'
        )} ${operation.toLowerCase()} ${i18n.t(
          'sweet_alert.jobs.worker_record'
        )}  "${this.dataClosing.row.worker.first_name} 
        ${this.dataClosing.row.worker.last_name}" ${i18n.t(
          'sweet_alert.jobs.of_the_farm'
        )} "${this.dataClosing.row.farm.name}" ${i18n.t(
          'sweet_alert.jobs.on_the_date'
        )}"${this.dataClosing.row.date}"?`,
        `${i18n.t('sweet_alert.jobs.yes')}, ${operation.toLowerCase()} ${i18n.t(
          'sweet_alert.jobs.typing'
        )}"`,
        0
      ).then((result) => {
        if (result.value) this.updateClosing();
      });
    },

    updateClosing() {
      if (this.closings()) {
        this.$emit('showHideLoading', true);
        const model = {
          route: 'works/laborheaders',
          closing: !this.dataClosing.row.closing,
          id: this.dataClosing.row.id,
          date_save: this.dataClosing.row.date_save,
          farm_id: this.dataClosing.row.farm_id,
        };

        Axios.updateMaster(model)
          .then((reps) => {
            this.$emit('showOrHideOperationColumn', model.closing);
            this.$emit('updateTable', {
              type: 1,
              id: model.id,
              response: {
                data: {
                  data: {
                    ...this.dataClosing.row,
                    closing: model.closing ? 1 : 0,
                  },
                  message: reps.data.message,
                },
              },
            });
            this.$emit('showHideLoading', false);
          })
          .catch((error) => {
            this.showMessageErrors(error);
            this.$emit('showHideLoading', false);
          });
      } else {
        this.showMessageAccess();
        this.$emit('showHideLoading', false);
      }
    },
  },
};
</script>
